import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';

@Component({
  selector: 'invoicing-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoicingProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'currentCreatedAt',
      'currentExecutionDate',
      'company',
      'projectPlacement.address',
      'productType',
      'productSize',
      'placer',
      'mostRecentAdjustmentPhoto',
      'thankYouMailSent',
      'displayStatus',
      'star'
    ];
  }

  protected getLocalStorageKey(): string {
    return 'InvoicingProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'status/Te_factureren';
  }

  public getPageTitle(): string {
    return 'Te factureren';
  }
}
